import { ApiErrorCode } from './api-error-codes';

export class ApiError extends Error {
  constructor(
    public readonly code: ApiErrorCode,
    public readonly originalError?: unknown,
    public readonly backendMessage?: string,
    public readonly backendCode?: number,
    public readonly backendArgs?: string[],
    public readonly httpStatus?: number,
    /**
     * Raw backend `args` exactly as received — preserves non-array shapes (e.g.
     * the object payload of structured validation errors). `backendArgs` only
     * keeps array args; consumers that need the structured object read this.
     */
    public readonly backendArgsRaw?: unknown
  ) {
    super(backendMessage ?? String(code));
    this.name = 'ApiError';
    // Ensure correct prototype chain in down-level targets
    Object.setPrototypeOf(this, ApiError.prototype);
    // Preserve V8 stack frames
    if ((Error as any).captureStackTrace) {
      (Error as any).captureStackTrace(this, ApiError);
    }
  }
}

export const createApiError = (
  code: ApiErrorCode,
  originalError?: unknown,
  backendMessage?: string,
  backendCode?: number,
  backendArgs?: string[],
  httpStatus?: number,
  backendArgsRaw?: unknown
): ApiError => {
  return new ApiError(
    code,
    originalError,
    backendMessage,
    backendCode,
    backendArgs,
    httpStatus,
    backendArgsRaw
  );
};
